import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const NotFoundStyle = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 100px 40px 100px;
    .notFoundIMG {
        width: 250px;
        height: 261.468px;
    }
    .viewContent {
        ${typography.bodyXs}
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        text-align: center;
        color: var(--sand-700);
    }
`;

export default NotFoundStyle;
